import { ThemeOptions } from '@mui/material/styles';

export const GcOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#002C77',
      light: '#0065AC',
      dark: '#001F52',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#009de0',
      light: '#3bb8f0',
      dark: '#0065AC',
      100: '#F5F5F5',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#C53532',
      light: '#EF4E45',
      dark: '#9A1C1F',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FFBE00',
      light: '#FFD240',
      dark: '#C98600',
      contrastText: '#202020DE',
    },
    info: {
      main: '#8096B2',
      light: '#A2B7CD',
      dark: '#627798',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#14853D',
      light: '#00AC41',
      dark: '#275D38',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: 'rgba(32, 32, 32, 0.87)',
      secondary: 'rgba(32, 32, 32, 0.54)',
      disabled: 'rgba(32, 32, 32, 0.38)',
    },
    action: {
      active: 'rgba(32, 32, 32, 0.54)',
      hover: 'rgba(32, 32, 32, 0.04)',
      selected: 'rgba(32, 32, 32, 0.08)',
      disabled: 'rgba(32, 32, 32, 0.26)',
      disabledBackground: 'rgba(32, 32, 32, 0.12)',
    },
    background: {
      default: 'rgba(240, 240, 240, 1)', // #f0f0f0
      paper: 'rgba(255, 255, 255, 1)', // #ffffff
    },
    divider: 'rgba(32, 32, 32, 0.12)', // #202020
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        textSizeSmall: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.813rem',
          fontWeight: 700,
          letterSpacing: '1.25px',
          lineHeight: '22px',
          textTransform: 'uppercase',
        },
        textSizeLarge: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.938rem',
          fontWeight: 700,
          letterSpacing: '1.25px',
          lineHeight: '26px',
          textTransform: 'uppercase',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.75rem',
          fontWeight: 400,
          letterSpacing: '0px',
          lineHeight: '12px',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.75rem',
          fontWeight: 400,
          letterSpacing: '0px',
          lineHeight: '20px',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '1rem',
          fontWeight: 400,
          letterSpacing: '0px',
          lineHeight: '19px',
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '1.25rem',
          fontWeight: 400,
          letterSpacing: '0px',
          lineHeight: '20px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.813rem',
          fontWeight: 400,
          letterSpacing: '0.16px',
          lineHeight: '18px',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.625rem',
          fontWeight: 400,
          letterSpacing: '0px',
          lineHeight: '14px',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          color: 'rgba(32, 32, 32, 0.87)',
          fontFamily: '"Arial", sans-serif',
          fontSize: '0.875rem',
          fontWeight: 700,
          letterSpacing: '0.15px',
          lineHeight: '24px',
        },
      },
    },
  },
  typography: {
    fontFamily: '"Arial", sans-serif',
    h1: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '6rem',
      lineHeight: '128px',
      letterSpacing: '-1.5px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    h2: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '3.75rem',
      lineHeight: '80px',
      letterSpacing: '0.5px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    h3: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '3rem',
      lineHeight: '64px',
      letterSpacing: '0px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    h4: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '2.125rem',
      lineHeight: '48px',
      letterSpacing: '0.25px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    h5: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '32px',
      letterSpacing: '0px',
      color: '#002C77',
    },
    h6: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: '26px',
      letterSpacing: '0.15px',
      color: '#009DE0',
    },
    subtitle1: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '28px',
      letterSpacing: '0.15px',
      color: '#009DE0',
    },
    subtitle2: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 700,
      fontSize: '0.875rem',
      lineHeight: '24px',
      letterSpacing: '0.1px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    body1: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '24px',
      letterSpacing: '0px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    body2: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '20px',
      letterSpacing: '0px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    button: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 700,
      fontSize: '0.875rem',
      letterSpacing: '1.25px',
      textTransform: 'uppercase',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    caption: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '20px',
      letterSpacing: '0px',
      color: 'rgba(32, 32, 32, 0.87)',
    },
    overline: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '0.688rem',
      lineHeight: '20px',
      letterSpacing: '1.5px',
      color: 'rgba(32, 32, 32, 0.87)',
      textTransform: 'uppercase',
    },
  },
};
